import { render, staticRenderFns } from "./BanSettings.vue?vue&type=template&id=bf98bf18&scoped=true"
import script from "./BanSettings.vue?vue&type=script&lang=js"
export * from "./BanSettings.vue?vue&type=script&lang=js"
import style0 from "./BanSettings.vue?vue&type=style&index=0&id=bf98bf18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf98bf18",
  null
  
)

export default component.exports